import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class ForteCheckoutPaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  apiAccessId: string;
  apiSecureKey: string;
  locationId: string;

  constructor(options?: Partial<ForteCheckoutPaymentProcessorAccountConfiguration>) {
    super(options);
  }
}
